<template>
  <div class="separator" />
</template>

<style scoped>
.separator {
  @apply pt-2 pb-1 border-t border-gray-200 dark:border-zinc-700 opacity-75;
}
</style>
